var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.communicationIsChecked),expression:"communicationIsChecked"}],staticClass:"fa fa-images",class:{ 'brand-red': _vm.communicationhasDocuments },on:{"click":function($event){_vm.$emit('openModal')}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d043d4ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/trials/DocumentsIcon.vue
// module id = 6TjI
// module chunks = 0